module.exports = __webpack_public_path__ + "img/icon_hot_new.13909746.png";